import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'la-basic-footer',
  styleUrls: ['./basic-footer.component.scss'],
  templateUrl: './basic-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasicFooterComponent {}
